import theme from 'src/theme';
import styled from 'styled-components';

export const TooltipContainer = styled.div`
    position: relative;
    display: inline-block;
    width: 100%;
    height: 100%;
`;

type TooltipContentProps = {
    type: 'information' | 'warning' | 'error';
};

const getTooltipColor = (type: 'information' | 'warning' | 'error') => {
    switch (type) {
        case 'information':
            return 'black';
        case 'warning':
            return theme.legacyColors.orange;
        case 'error':
            return theme.legacyColors.errorText;
    }
};

export const TooltipContent = styled.div<TooltipContentProps>`
    position: fixed; /* Changed from absolute to fixed */
    /* Will be set dynamically in the component */
    background-color: white;
    color: ${(props) => getTooltipColor(props.type)};
    padding: 5px;
    border-radius: 4px;
    border: 1px solid ${theme.legacyColors.greyBorderColor};
    z-index: 9999;
    max-width: 300px;
    min-width: 180px;
    height: fit-content;
    text-align: center;
    white-space: normal;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
    pointer-events: none; /* Prevents the tooltip from interfering with mouse events */
`;
